import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import state from './state';

const AnnouncementStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
export default AnnouncementStore;
